import { Table } from 'reactstrap';

export const EquipmentOnSite = ({ resources }) => (
    <Table className="table table-sm" bordered responsive>
        <thead>
            <th>
                Resource
            </th>

            <th>
                # On Site
            </th>
        </thead>

        <tbody>
            {(resources || []).map(resource => (
                <tr>
                    <td>
                        {resource.equipmentTypeName}
                    </td>

                    <td>
                        {resource.actualQuantity}
                    </td>
                </tr>
            ))}
        </tbody>
    </Table>
);